<header mat-dialog-title>
  <div class="header-title-content">
    <span *ngIf="riders">Modifica fattorino: {{ riders.name }} {{ riders.surname }} </span>
    <span *ngIf="!riders" class="new-item">Nuovo fattorino</span>
  </div>

  <div class="header-actions" *ngIf="riders">
    <button mat-icon-button [mat-menu-trigger-for]="actionMenu">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu x-position="before" overlapTrigger="false" #actionMenu="matMenu">
      <button mat-menu-item (click)="deleteRider()">
        <mat-icon>delete</mat-icon>
        Elimina fattorino
      </button>
    </mat-menu>
  </div>
</header>

<mat-dialog-content>
  <form [formGroup]="ridersForm" novalidate>

    <div class="u-flex-full">
      <mat-form-field class="u-full-width">
        <mat-label>Nome</mat-label>
        <input matInput formControlName="name" placeholder="Nome" required>
        <mat-error>Campo Obbligatorio</mat-error>
      </mat-form-field>

      <mat-form-field class="u-full-width">
        <mat-label>Cognome</mat-label>
        <input matInput formControlName="surname" placeholder="Cognome" required>
        <mat-error>Campo Obbligatorio</mat-error>
      </mat-form-field>
    </div>

    <div class="u-flex-full">
      <mat-form-field class="u-full-width">
        <mat-label>Telefono</mat-label>
        <span matPrefix>+39 &nbsp;</span>
        <input type="phone" #phone matInput placeholder="Telefono" formControlName="phone" required>
        <mat-hint align="end">{{ phone.value.length }} / 10</mat-hint>
        <mat-error>Campo Obbligatorio</mat-error>
      </mat-form-field>
    </div>

    <div class="u-flex-full">
      <mat-form-field class="u-full-width">
        <mat-label>Email</mat-label>
        <input type="email" matInput placeholder="Email" formControlName="email" required>
        <mat-error>Campo Obbligatorio</mat-error>
      </mat-form-field>

       <mat-form-field class="u-full-width">
        <mat-label>Password</mat-label>
        <input matInput type="password" #password formControlName="password" 
        placeholder="{{ isEditing && hasPassword ? '******' : 'Password' }}" (focus)="onPasswordFocus()" required>
        <mat-error>Campo Obbligatorio</mat-error>
      </mat-form-field>
    </div>
 
    <div class="u-flex-full">
      <mat-slide-toggle formControlName="active" color="primary">
        Attivo
      </mat-slide-toggle>
    </div>

  </form>
</mat-dialog-content>


<mat-dialog-actions>
  <div class="left-actions">
      <button mat-raised-button (click)="revert()" [disabled]="ridersForm.pristine">
          Reset
      </button>
      <button mat-raised-button color="primary" (click)="save()" [disabled]="ridersForm.pristine || !ridersForm.valid">
          Salva
      </button>
  </div>
  <div class="right-actions">
      <button mat-raised-button (click)="close()">
          Chiudi
      </button>
  </div>
</mat-dialog-actions>

<!-- <div class="footer" *ngIf="riders | async">
  <div class="spinner">
    <div class="rect1"></div>
    <div class="rect2"></div>
    <div class="rect3"></div>
    <div class="rect4"></div>
    <div class="rect5"></div>
  </div>
</div> -->